$('#menu-toggle').click(function () {
    $(this).parent().parent().toggleClass('open');

    if ($('#menu-toggle').parent().parent().hasClass('open')) {
        $('body').addClass("fixed-position");
        $('#menu-toggle').addClass('is-active');
    } else {
        $('body').removeClass("fixed-position");
        $('#menu-toggle').removeClass('is-active');
    }
});

$(document).on('click', function (e) {
    if ($('#menu-toggle').parent().parent().hasClass('open')) {
        let menu = $('#navigator');
        let hamburger = $('#menu-toggle');
        if (!hamburger.is(e.target)
            && hamburger.has(e.target).length === 0
            && !menu.is(e.target)
            && menu.has(e.target).length === 0) {
            $('#menu-toggle').parent().parent().removeClass('open');
            $('body').removeClass("fixed-position");
            $('#menu-toggle').removeClass('is-active');
        }
    }
});

/* Use compact Google reCaptcha smaller screens */
if($('.g-recaptcha').length) {
    if(window.screen.width < 400) {
        let recaptcha = $('.g-recaptcha')[0];
        recaptcha.dataset.size = 'compact';
    }
}

/* Image Modal */
/*let modal = $("#imgModal");

// Get the image and insert it inside the modal - use its "alt" text as a caption
let modalImg = $("#mImg");
$('.viewable').on('click', function() {
    modalImg.attr('src', $(this).data('lrg-image'));
    modal.css('display', 'flex');
});

// Get the <span> element that closes the modal
let btnClose = $("#mClose");

// When the user clicks on <span> (x), close the modal
btnClose.on('click', function() {
    modal.hide();
});

// Close modal if user clicks outside image
modal.on('click', function(e) {
    if(modal.is(':visible') && e.target.id !== 'mImg') {
        modal.hide();
    }
});*/
